import { Amplify } from 'aws-amplify'

import { getEnv } from '@/config/env'

let configured = false

export function configureAmplify(): void {
  if (configured) return

  const env = getEnv()

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: env.VITE_COGNITO_USER_POOL_ID,
        userPoolClientId: env.VITE_COGNITO_CLIENT_ID,
      },
    },
  })

  configured = true
}

export function resetAmplifyConfigurationForTests(): void {
  configured = false
}
